module.exports = __webpack_public_path__ + "static/media/dinger-asia.e9912f38.png";